import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import Link from '../Link/Link';
import classNames from 'classnames';
import Icon from '../Icon/Icon';
var css = {
  "button": "rui-apowA",
  "normal": "rui-UGVY0",
  "small": "rui-DUJOe",
  "xsmall": "rui-I9bpf",
  "fixed": "rui-oAVsQ",
  "disabled": "rui-WmTqr",
  "primaryBtn": "rui-E75l5",
  "invert": "rui-4OLAT",
  "iconPath": "rui-B79vz",
  "secondaryBtn": "rui-htytx",
  "tertiaryBtn": "rui-Ghwwu",
  "blueLink": "rui-YSvFo",
  "roundCorners": "rui-H9g30",
  "icon": "rui-Uhm3b",
  "rightIcon": "rui-9OyWy"
};
var DEFAULT_ICON_SIZE = 22;
var NEW_TYPES = {
  'primaryBtn': 'primaryBtn',
  'secondaryBtn': 'secondaryBtn',
  'tertiaryBtn': 'tertiaryBtn',
  'blueLink': 'blueLink'
};
export var OLD_NEW_MAPPING = Object.assign({
  'primary': NEW_TYPES.primaryBtn,
  'charcoal': NEW_TYPES.primaryBtn,
  'flat': NEW_TYPES.tertiaryBtn,
  'outline': NEW_TYPES.secondaryBtn,
  'outlineInvert': NEW_TYPES.secondaryBtn,
  'fav': NEW_TYPES.primaryBtn,
  'favInvert': NEW_TYPES.secondaryBtn,
  'btnMain': NEW_TYPES.primaryBtn,
  'btnOutline': NEW_TYPES.secondaryBtn,
  'btnPill': NEW_TYPES.primaryBtn,
  'clear': NEW_TYPES.primaryBtn,
  'btnDisabled': NEW_TYPES.primaryBtn
}, NEW_TYPES);
var ICON_COLOR_BTN_CONFIG = {
  'primaryBtn': 'white',
  'secondaryBtn': 'primary',
  'tertiaryBtn': 'primary'
};
export var ICON_PLACEMENT = {
  LEFT: 'left',
  RIGHT: 'right'
};
var Button = function Button(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'tertiaryBtn' : _ref$type,
    disabled = _ref.disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'normal' : _ref$size,
    fixed = _ref.fixed,
    htmlType = _ref.htmlType,
    icon = _ref.icon,
    className = _ref.className,
    href = _ref.href,
    onClick = _ref.onClick,
    dataAutId = _ref['data-aut-id'],
    rel = _ref.rel,
    iconDirection = _ref.iconDirection,
    children = _ref.children,
    invert = _ref.invert,
    roundCorners = _ref.roundCorners,
    style = _ref.style,
    iconPlacement = _ref.iconPlacement,
    iconSize = _ref.iconSize,
    theme = _ref.theme,
    iconColorValue = _ref.iconColorValue;
  var btnType = OLD_NEW_MAPPING[type] || 'primaryBtn';
  var iconColor = iconColorValue || ICON_COLOR_BTN_CONFIG[btnType];
  var props;
  var Tag;
  if (href) {
    Tag = Link;
    props = {
      to: href,
      rel: rel,
      className: css.link
    };
  } else {
    Tag = 'button';
    props = {
      type: htmlType
    };
  }
  function renderIcon() {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames(css.icon, _defineProperty({}, css.rightIcon, iconPlacement === ICON_PLACEMENT.RIGHT))
    }, /*#__PURE__*/React.createElement(Icon, {
      icon: icon,
      color: iconColor,
      size: iconSize || DEFAULT_ICON_SIZE,
      direction: iconDirection,
      overrideClassName: css.iconPath,
      theme: theme
    }));
  }
  return /*#__PURE__*/React.createElement(Tag, Object.assign({}, props, {
    "data-aut-id": dataAutId,
    className: classNames(css.button, css[btnType], css[size], className, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, css.disabled, disabled), css.fixed, fixed), css.roundCorners, roundCorners), css.invert, invert)),
    onClick: onClick,
    disabled: disabled,
    style: style
  }), icon && iconPlacement === ICON_PLACEMENT.LEFT && renderIcon(), children, icon && iconPlacement === ICON_PLACEMENT.RIGHT && renderIcon());
};
Button.defaultProps = {
  type: 'tertiaryBtn',
  disabled: false,
  size: 'normal',
  fixed: false,
  icon: '',
  className: '',
  href: '',
  htmlType: 'button',
  onClick: undefined,
  'data-aut-id': '',
  rel: '',
  iconDirection: 'ltr',
  invert: false,
  roundCorners: false,
  style: {},
  iconPlacement: ICON_PLACEMENT.LEFT
};
export default Button;